export default __webpack_public_path__ + "static/media/special-ability.f1d4a2b0.webp";